import { render, staticRenderFns } from "./EditCommunicationTemplateTextForm.vue?vue&type=template&id=3a93a0af&scoped=true&"
import script from "./EditCommunicationTemplateTextForm.vue?vue&type=script&lang=js&"
export * from "./EditCommunicationTemplateTextForm.vue?vue&type=script&lang=js&"
import style0 from "./EditCommunicationTemplateTextForm.vue?vue&type=style&index=0&id=3a93a0af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a93a0af",
  null
  
)

export default component.exports